import { CommonModule, NgClass } from "@angular/common";
import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

export type ButtonColor = "primary" | "accent" | "warn" | "neutral";

export type ButtonSize = "small-button" | "medium-button" | "large-button";

export type ButtonVariant = "raised" | "stroked" | "flat";

@Component({
    selector: "v2-button-wrapper",
    templateUrl: "button-wrapper.component.html",
    standalone: true,
    imports: [CommonModule, MatIconModule, MatButtonModule],
})
export class ButtonWrapperComponent {
    @Input() color: ButtonColor = "neutral";

    @Input() icon: string | null = null;

    @Input() text: string = "";

    @Input() size: ButtonSize = "medium-button";

    @Input() variant: ButtonVariant = "flat";

    @Input() bold: boolean = false;

    @Input() disabled: boolean = false;
}
